<template>
  <div
    v-tinymce="options"
    @mce-change="(about) => offerSectionSet({ aboutGfu: about })"
    @mce-dirty="() => $emit('dirty')">
    <div v-if="offerSections.aboutGfu" v-html="offerSections.aboutGfu"></div>
    <div v-else class="about-gfu">
      <h3>{{ $t('aboutGfu.heading') }}</h3>
      <p class="mb-4">
        <span class="custom-spacing d-block">{{ $t('aboutGfu.intro') }}</span>
        <span class="custom-spacing d-block" v-html="$t('aboutGfu.clients', { count: formattedClientCount })"></span>
        <span class="custom-spacing d-block" v-html="$t('aboutGfu.seminars', { count: formattedSeminarCount })"></span>
      </p>
      <b-row>
        <b-col md="6">
          <strong class="h5 d-block">{{ $t('aboutGfu.handsOnHeading') }}</strong>
          <p>{{ $t('aboutGfu.handsOn') }}</p>
        </b-col>
        <b-col md="6">
          <strong class="h5 d-block">{{ $t('aboutGfu.satisfactionHeading') }}</strong>
          <p>{{ $t('aboutGfu.satisfaction') }}</p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import { formatNumber } from "../../misc/LocaleFormat";
export default {
  name: "AboutGfu",
  computed: {
    ...mapGetters(["offerSections", "clientCount", "seminarCount", "offer"]),
    formattedClientCount() {
      return formatNumber(this.clientCount || 3500, this.offer.language || 'de');
    },
    formattedSeminarCount() {
      return formatNumber(this.seminarCount || 3500, this.offer.language || 'de');
    },
  },
  mounted() {
    this.fetchClientAndSeminarCount();
  },
  methods: {
    ...mapMutations(["offerSectionSet"]),
    ...mapActions(["fetchClientAndSeminarCount"]),
  },
};
</script>

<style scoped>
.custom-spacing {
  margin-bottom: 0.75rem;
}
</style>
